import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { getSurvey } from '../../../action/guestRequest'
import { sendAnalytics } from '../../../action/homeAction'
import { getDefaultAnalyticsLabel } from '../../JS/utility'
import { withTranslation } from 'react-i18next'
import { CMSPath } from '../../../config/constant'

function GdprPolicy(props) {

    const { t } = props;
    const [surveyResponse, setSurveyResponse] = useState({})
    const [privacyNotes, setPrivacyNotes] = useState("")
    const [gdprSections, setGdprSections] = useState("")
    const [questions, setQuestions] = useState([])

    const ref = useRef()

    function handleChange(e) {
        let res = {}
        let obj = JSON.parse(`{"${e.target.name}": "${e.target.value}"}`)
        res = {...surveyResponse, ...obj};
        setSurveyResponse(res);
        console.log("GDPR-Response", res)
        if(e.target.value) localStorage.setItem("GDPR-Response", JSON.stringify(res));
        // switch(e.target.name){
        //     case "Survey":  res = {...surveyResponse, "survey": e.target.value};
        //                     setSurveyResponse(res);
        //                     localStorage.setItem("GDPR-Response", JSON.stringify(res));
        //                     break;
        //     case "Offers":  res = {...surveyResponse, "offers": e.target.value};
        //                     setSurveyResponse(res);
        //                     localStorage.setItem("GDPR-Response", JSON.stringify(res));
        //                     break;
        //     default: break;
        // }

    }

    useEffect(() => {
        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        const checkinSessionToken = localStorage.getItem("checkinSessionToken");
        props.setLoader(true, "Loading data. Please wait...")
        props.getSurvey(props.currentWidget.surveyId, 
            (status) => {
                props.setLoader(false, "") 
                if(!status) {
                    props.setAPIFailScreen(true)
                    props.sendAnalytics(
                        null, // as no guesdetails in logout state 
                        props.currentWidgetObj.widgetType || "Mobile Check-in", 
                        "GDPR POLICY - FAILED", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "GDPR POLICY", "widgetSessionId": checkinSessionToken},
                        0, 
                        false // guest is not logged in
                    );
                }
        })
        props.sendAnalytics(
            null, // as no guesdetails in logout state 
            props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "GDPR POLICY", 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "GDPR POLICY", "widgetSessionId": checkinSessionToken},
            0, 
            false // guest is not logged in
        );
    
    }, [])

    useEffect(() => {
        setGdprSections(props.survey.thanksText)
        setQuestions(props.survey.questions)
        setPrivacyNotes(props.survey.title)
    },[props.survey])
    

    function addClass() {
        ref.current.classList.add('showall')
    }
    function removeClass() {
       ref.current.classList.remove('showall')
    }

  return (
    <div class="main-container" >{console.log("surveyResponse",surveyResponse)}
		<header class="inner-pages w-footer subpages">
			<a onClick={props.goBack} class="button-back"></a>
			<div class="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
				{/* <p class="bold">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
			</div>
		</header>
		<section class="widgets padding-0 margin-0 container-bg">

            <div class="widget-header widget-header-checkin-inner">
                { props.currentWidgetObj.widgetHeaderImageUrl && 
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
            </div>

			<div class="widgets">
				<div class="form-window">
					<div class="form-window-heading">
						Privacy and GDPR
					</div>
					<div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
						<div ref={ref} class="preview-text">
							<div class="form-row margin-bottom-2">
							  <div dangerouslySetInnerHTML={{__html: privacyNotes}}></div>
							  <div class="show-more">
									<a onClick={addClass}>read all</a>
								</div>
								<div class="show-less">
									<a onClick={removeClass}>show less</a>
								</div>
							</div>
							<div class="form-row">
								<div dangerouslySetInnerHTML={{__html: gdprSections}}></div>
                                {
                                    questions&&questions.map((obj, index) => <>
                                        <p>{obj.question}</p>
                                        <div class="optgroup">
                                            <input onClick={handleChange} type="radio" name={`survey${index}`} value={obj.happyQualityPlusRequestId} />Yes
                                            <input onClick={handleChange} type="radio" name={`survey${index}`} value={obj.unhappyQualityPlusRequestId} />No
                                        </div>        
                                    </>)
                                }
								{/* <p>Receiving special offers and exciting news about Columbia Beach Resort, Pissouri. We will not share your email with any other company, organization or individual.</p>
								<div class="optgroup">
									<input onClick={handleChange} type="radio" name="Offers" value="Yes" />Yes
									<input onClick={handleChange} type="radio" name="Offers" value="No" />No
								</div>
								<p>Performing market research via surveys to better serve my needs</p>
								<div class="optgroup">
									<input onClick={handleChange} type="radio" name="Survey" value="Yes" />Yes
									<input onClick={handleChange} type="radio" name="Survey" value="No" />No
								</div> */}
							</div>
						</div>
						<div class="form-controls">
							<button class="primary w-100" disabled={Object.keys(surveyResponse).length < 2} onClick={props.goNext}>Accept</button>
							<button class="secondary w-100 margin-top-1" onClick={props.goBack}>Decline</button>
						</div>
					</div>
				</div>
				
			</div>
		</section>
	</div>
  )
}

const mapStateToProps = (state, props) => {
    return {
        survey: state.store.survey,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
    }
}

export default connect(mapStateToProps, {getSurvey, sendAnalytics})(withTranslation('translations')(GdprPolicy));